import {http} from '../config';
export default{


    //Ajustar para recibir parametro
    listarCategoriasPorVendedor:(vendedor)=>{
        return http.get('api/categorias/lista/publico/'+vendedor);
    },



    //Ajustar para recibir parametro
    listarCategoriasPublico:(identificador)=>{
        return http.get('api/categorias/publico/'+identificador);
    },


    listarCategorias:()=>{
        return http.get('api/categorias');
    },
    listarCategoriasTodosPublico:()=>{
        return http.get('api/categorias/todos/publico');
    },


    
    save:(categoria)=>{
        return http.post('api/categorias',categoria)
    },
   update: (categoria) => {
  return http.put('api/categorias/' + categoria.id, categoria)
},
    delete:(categoria)=>{
        return http.delete('api/categorias/'+categoria.id)
    }
}
